import type { ComponentProps } from 'react';

import { Slot } from '@radix-ui/react-slot';
import { tv, type VariantProps } from 'tailwind-variants';

export const flexVariants = tv({
  base: 'flex',
  variants: {
    direction: {
      row: 'flex-row items-center',
      rowReverse: 'flex-row-reverse items-center',
      column: 'flex-col',
    },
    grow: {
      true: 'grow',
    },
    gap: {
      0: 'gap-0',
      0.5: 'gap-0.5',
      1: 'gap-1',
      1.5: 'gap-1.5',
      2: 'gap-2',
      3: 'gap-3',
      4: 'gap-4',
      5: 'gap-5',
      6: 'gap-6',
      7: 'gap-7',
      8: 'gap-8',
      9: 'gap-9',
      10: 'gap-10',
      12: 'gap-12',
      14: 'gap-14',
      16: 'gap-16',
    },
    justifyContent: {
      start: 'justify-start',
      end: 'justify-end',
      center: 'justify-center',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    },
    alignItems: {
      start: 'items-start',
      end: 'items-end',
      center: 'items-center',
      baseline: 'items-baseline',
      stretch: 'items-stretch',
    },
  },
  defaultVariants: {
    gap: 0,
    direction: 'column',
  },
});

export interface FlexProps extends VariantProps<typeof flexVariants>, ComponentProps<'div'> {
  asChild?: boolean;
}

export function Flex({
  children,
  direction,
  grow,
  gap,
  justifyContent,
  alignItems,
  className,
  asChild,
  ...props
}: FlexProps): React.ReactElement {
  const Comp = asChild ? Slot : 'div';

  return (
    <Comp
      data-slot="flex"
      className={flexVariants({ direction, grow, gap, justifyContent, alignItems, className })}
      {...props}
    >
      {children}
    </Comp>
  );
}
